import * as React from 'react';
import { AuthContext } from '../LocalAuthWrapper';
import Layout from './Layout';
import RealTimeCaptioningInfo from './RealTimeCaptioningInfo';
import BroadCastListTable from './BroadcastListTable';

import './RealTimeCaptioning.css';
import { Tabs } from 'antd';

type RealTimeCaptioningProps = {
  activeTab: 'útsendingar' | 'streymislyklar' | 'bútar';
};

const RealTimeCaptioning: React.FC<RealTimeCaptioningProps> = (props: RealTimeCaptioningProps) => (
  <Layout>
    <AuthContext.Consumer>
      {(value) => {
        const hasRTCRights: boolean = !!value?.userDetails?.groups?.includes('tal-tiro-is:rauntimatextun');
        return (
          <div className='real-time-captioning-container'>
            <h1>Rauntímatextun</h1>
            {hasRTCRights ? (
              // We can add more tabs here in the future. For stream key management or segment view for example.
              <Tabs
                defaultActiveKey='útsendingar'
                activeKey={props.activeTab}
                type='card'
                items={[
                  {
                    label: 'Útsendingar',
                    key: 'útsendingar',
                    children: (
                      <div className='container-wrapper'>
                        <BroadCastListTable userId={value.userDetails ? value.userDetails.uid : 'no user id'} />
                      </div>
                    ),
                  },
                ]}
              />
            ) : (
              <RealTimeCaptioningInfo />
            )}
          </div>
        );
      }}
    </AuthContext.Consumer>
  </Layout>
);

export default RealTimeCaptioning;
